import { Factory } from '../../../services/Factory';
import { SearchVisibility } from '../../../model/search/advanced/SearchVisibility';

namespace app.directives.search.advanced {

  export interface IShareSearchScope extends angular.IScope {
    search: AdvancedSearch;
    project;
  }

  export interface IShareSearchAttributes extends angular.IAttributes {
  }

  export class ShareSearch implements angular.IDirective {
    public restrict = 'E';
    public templateUrl: string;
    public scope = {search: '=ngModel', project: '='};
    public require = ['ngModel'];
    public link: (scope: IShareSearchScope, element: angular.IAugmentedJQuery, attrs: IShareSearchAttributes) => void;

    constructor(rootScope: IRootScope, searchService: app.services.search.advanced.SearchService) {
      this.templateUrl = "partials/search/advanced/share_search.html";
      this.link = (scope: IShareSearchScope, element: angular.IAugmentedJQuery, attrs: IShareSearchAttributes) => {
        scope.$watch("search", (s: AdvancedSearch) => {
          s.visibility = SearchVisibility.Private;
          searchService.Save(scope.project, s);
        }, true);
      };
    }
  }

  frontendApp.directive("iioShareAdvancedSearch", ["$rootScope", "AdvancedSearchService", Factory.Create(ShareSearch)]);
}
